<template>
    <div
        v-if="items.length > 0 || edit"
        :id="block.id || `${block.type}-${uid}`"
        class="mt-6 mt-md-8 mt-lg-10"
    >
        <div class="page-container">

            <div
                v-if="edit"
                class="edit"
            >
                <button
                    class="btn-bg btn-lg rounded icon-ic-pencil-outline elevate edit-btn"
                    @click="$emit('openIconListEditor')"
                />
            </div>

            <div v-if="title.text || description.text" class="row">
                <div class="col-12 col-lg-10 offset-lg-1 ta-center">

                    <h2 v-if="title.text" class="h4 h3-sm h2-md mt-0 mb-2 mb-sm-3 mb-md-4" :class="title.class" v-html="title.text" />

                    <div
                        v-if="description.text"
                        class="desc mb-2 mt-sm-n1 mb-sm-3 mt-md-n2 mb-md-4"
                        :class="description.class"
                        v-html="description.text"
                    />

                </div>
            </div>

            <div class="row mb-n2 mb-sm-n3 mb-xl-n4">
                <div
                    v-for="(item, i) in items"
                    :key="`item-${i}`"
                    class="col-12 col-md-6 col-xl-4 mb-2 mb-sm-3 mb-xl-4"
                    :class="content.class"
                >

                    <div
                        class="list-item p-lg-2"
                        :class="item.class"
                    >
                        <div class="item-icon mr-2">
                            <img
                                v-if="item.icon.light"
                                class="scheme-light-block"
                                :src="item.icon.light"
                                :width="item.icon.width"
                                :height="item.icon.height"
                                loading="lazy"
                                alt=""
                            >
                            <img
                                v-if="item.icon.dark"
                                class="scheme-dark-block"
                                :src="item.icon.dark"
                                :width="item.icon.width"
                                :height="item.icon.height"
                                loading="lazy"
                                alt=""
                            >
                            <img
                                v-if="item.icon.src"
                                :src="item.icon.src"
                                :width="item.icon.width"
                                :height="item.icon.height"
                                loading="lazy"
                                alt=""
                            >
                        </div>

                        <div class="item-content">
                            <div
                                v-if="item.title"
                                class="item-title mb-h"
                                v-html="item.title"
                            />

                            <div class="item-text">
                                <p
                                    v-for="(p, j) in paragraphs(item.text)"
                                    :key="`item-${i}-p-${j}`"
                                    v-html="p"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>


<script>
    let uid = 0;

    import blockPropertyObject from '~/mixins/course-landing/blockPropertyObject.js';
    import paragraphs from '~/mixins/course-landing/paragraphs.js';

    export default {
        props: {
            block: Object,
            edit:  Boolean,
        },

        mixins: [
            blockPropertyObject,
            paragraphs,
        ],

        data () {
            uid++;

            return {
                uid
            };
        },

        computed: {
            title () {
                return this.blockPropertyObject(this.block.title, 'text');
            },

            description () {
                return this.blockPropertyObject(this.block.description, 'text');
            },

            content () {
                return this.blockPropertyObject(this.block.content, 'items');
            },

            items () {
                const content = this.content;

                if (!('items' in content)) return [];

                return content.items.map(item => {
                    return this.blockPropertyObject(item, 'text');
                });
            },
        },
    }
</script>


<style lang="postcss" scoped>
    .desc {
        @media screen and (min-width: 576px) {
            font-size:   19px;
            line-height: 1.263158;
        }

        @media screen and (min-width: 992px) {
            font-size:   24px;
            line-height: 1.166667;
        }
    }

    .edit {
        position: relative;
    }

    .edit-btn {
        position: absolute;
        top:      -6px;
        right:    -8px;
        z-index:  10;
    }

    .list-item {
        display:     flex;
        flex-flow:   row nowrap;
        align-items: flex-start;
    }

    .item-icon {
        width: 32px;
        flex:  0 0 auto;

        :deep(img) {
            object-fit:      contain;
            object-position: 50% 0;

            display: block;
            width:   32px;
            height:  auto;
        }
    }

    .item-title {
        font-size:   18px;
        font-weight: 800;
        line-height: 1.333333;
        text-wrap: balance;

        @media screen and (min-width: 576px) {
            font-size:   19px;
            line-height: 1.263158;
        }
    }

    .item-text {
        p {
            margin-bottom: 8px;
        }

        :last-child {
            margin-bottom: 0;
        }
    }
</style>
